<p-dialog
  [(visible)]="visible"
  header=""
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '550px' }"
  styleClass="session-expired-dialog"
>
  <div class="dialog-content">
    <!-- Icon avec animation moderne -->
    <div class="icon-container">
      <div class="warning-circle">
        <div class="icon-bg-layer"></div>
        <i class="pi pi-clock warning-icon"></i>
      </div>
      <div class="pulse-ring"></div>
    </div>
    
    <!-- Message principal avec design moderne -->
    <div class="message">
      <h2 class="main-title">
        <span class="gradient-text">Session Expirée</span>
      </h2>
      <p class="subtitle">Votre session a expiré pour des raisons de sécurité.</p>
      <p class="description">Veuillez vous reconnecter pour continuer à utiliser l'application.</p>
    </div>

    <!-- Info box avec icône -->
    <div class="info-box">
      <i class="pi pi-info-circle"></i>
      <span>Vos données non sauvegardées seront perdues</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button 
        label="Se reconnecter maintenant" 
        icon="pi pi-sign-in"
        (click)="reconnect()"
        severity="primary"
        size="large"
        styleClass="reconnect-button"
      ></p-button>
      <p-button 
        label="Annuler" 
        icon="pi pi-times"
        (click)="cancel()"
        severity="secondary"
        size="large"
        styleClass="cancel-button"
        [text]="true"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>